export default function hasOwnProperty<X extends {}, Y extends PropertyKey>( // eslint-disable-next-line @typescript-eslint/ban-types
  obj: X,
  prop: Y
): obj is X & Record<Y, unknown> {
  if (!obj) {
    return false;
  }
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
